<div class="bx bg-bx-drk">
  <div class="deco-out psu-bfr psu-aft rel">
    <div class="deco-in hp: vp: psu-bfr psu-aft rel">
      <canvas #SkillsChart></canvas>
    </div>
  </div>
</div>
